module.exports = __webpack_public_path__ + "media/images/logo--warranty-f7ddbf392e81310e18222ba2fb124258.svg";